module.exports = __webpack_public_path__ + "img/logo.07a848be.svg";